import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { AdobeLaunchService } from '../../adobe-launch/adobe-launch.service';

@Component({
  selector: 'methodology',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent],
  templateUrl: './methodology.component.html',
  styleUrl: './methodology.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MethodologyComponent implements OnInit {
  readonly researchPaperLink = 'https://advisors.vanguard.com/content/dam/fas/pdfs/ISGBETR.pdf';
  methodologyContent = content.Data.v4_rcc_root.content.methodology;

  constructor(
    private readonly contentService: ContentService,
    private readonly adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit(): void {
    this.contentService.getContent().subscribe((data) => {
      this.methodologyContent = data.Data.v4_rcc_root.content.methodology;
    });
  }

  public adobeTaggingPDFDownloadEvent(pdfFile): void {
    const fileName = `${pdfFile}`;
    this.adobeLaunchService.downloadAction(fileName);
  }
}
